import { render, staticRenderFns } from "./PigPen.vue?vue&type=template&id=25fff323&scoped=true&"
import script from "./PigPen.vue?vue&type=script&lang=ts&"
export * from "./PigPen.vue?vue&type=script&lang=ts&"
import style0 from "./PigPen.vue?vue&type=style&index=0&id=25fff323&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fff323",
  null
  
)

export default component.exports